module.exports = __webpack_public_path__ + "static/media/monitoring6.5cd1bed0.png";